export { default } from "./PollOptionWithResults";
